<template>
  <v-card
    flat
    v-bind="$attrs"
  >
    <v-card-title
      class="pa-0"
      :style="additionalStyle"
    >
      <slot name="header" />
      <v-spacer />
      <slot name="actions" />
    </v-card-title>
    <v-divider v-if="!hideDivider" class="mb-4 neutral tone-200"/>
    <v-card-text class="px-0 pb-6 pt-0">
      <slot name="content" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    hideDivider: {
      type: Boolean,
      default: false,
    },
    titleBackgroundImagePath: {
      type: String,
      default: null,
    },
  },
  computed: {
    additionalStyle() {
      if (this.titleBackgroundImagePath && this.$vuetify.breakpoint.mdAndDown) {
        return {
          backgroundImage: `url(${this.titleBackgroundImagePath})`,
          backgroundSize: 'cover',
          paddingBottom: '144px !important',
        };
      }
      return {};
    },
  },
};
</script>
